var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit, QueryList, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { PlaceType } from '../place.category/customize.place.category.component';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { clone } from '../../../common/extensions';
import { CustomDefaultPlaceCategoryItemEditedStore, CustomDefaultPlaceCategoryItemSelectionStore, } from '../../../stores/hub.calendar.store';
import { PlaceService } from '../../../services/place.service';
import { ModalService } from '../../../common/services/modal.service';
import { routeConfigs } from '../../../common/constants/route.config';
import { AlertifyService } from '../../../services/alertify.service';
import { ConfigService } from '../../../services/config.service';
import { ShowCategoryLinkModalComponent } from '../show.category.link.modal/show.category.link.modal.component';
import { CategoryLinkModalData, ShowCategoryLinkModalActions, } from '../show.category.link.modal/show.category.link.modal.provider';
var AccordionEditorComponent = /** @class */ (function (_super) {
    __extends(AccordionEditorComponent, _super);
    function AccordionEditorComponent(formBuilder, activatedRoute, alertify, modalService, customDefaultPlaceCategoryItemSelectionStore, customDefaultPlaceCategoryItemEditedStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.customDefaultPlaceCategoryItemSelectionStore = customDefaultPlaceCategoryItemSelectionStore;
        _this.customDefaultPlaceCategoryItemEditedStore = customDefaultPlaceCategoryItemEditedStore;
        _this.isUseDefault = true;
        _this.isExpanded = false;
        _this.isSelected = false;
        _this.isEditMode = true;
        _this.maxLevels = 3;
        _this.onCategoryClick = new EventEmitter();
        _this.onSubCategoryAdded = new EventEmitter();
        _this.onRemoved = new EventEmitter();
        _this.onToggle = new EventEmitter();
        return _this;
    }
    AccordionEditorComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.tempTitle = clone(this.item.title);
        this.form = this.formBuilder.group({
            categoryName: [null, []],
        });
        this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.takeUntil(this.isDestroyed).subscribe(function (data) {
            if (data && data.id) {
                _this.isSelected = _this.item.id === data.id;
            }
            else {
                _this.isSelected = false;
            }
        });
    };
    AccordionEditorComponent.prototype.changeUseDefault = function () { };
    AccordionEditorComponent.prototype.expandCategory = function () { };
    AccordionEditorComponent.prototype.toggle = function (isExpanded) {
        this.isExpanded = isExpanded;
        this.onToggle.emit(isExpanded);
    };
    AccordionEditorComponent.prototype.setCategories = function (item) {
        this.onCategoryClick.emit(item);
        // for changing selection style
        this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next(item);
    };
    AccordionEditorComponent.prototype.syncCategoryListAreaHeightWithEditorAreaHeight = function () {
        setTimeout(function () {
            var editorArea = document.getElementById('editor-area');
            var categoryListArea = document.getElementById('sub-category-wrap');
            if (!editorArea || !categoryListArea)
                return;
            var rect = editorArea.getBoundingClientRect();
            categoryListArea.style.height = rect.height - 16 + "px";
        });
    };
    AccordionEditorComponent.prototype.dragEnter = function ($event) {
        if ($event && $event.currentTarget) {
            this.restoreItemStyle();
            $event.currentTarget.style.outline = '2px dashed orange';
        }
    };
    AccordionEditorComponent.prototype.restoreItemStyle = function () {
        this.accordions.toArray().forEach(function (x) {
            x.nativeElement.style.outline = 'none';
        });
    };
    AccordionEditorComponent.prototype.onItemDrop = function (e, targetIndex, parent) {
        var _this = this;
        console.log({ e: e });
        console.log({ targetIndex: targetIndex });
        var dragItemIndex = parent.subCategories.indexOf(e.dragData);
        console.log({ dragItemIndex: dragItemIndex });
        // swap items
        _a = [
            parent.subCategories[dragItemIndex],
            parent.subCategories[targetIndex],
        ], parent.subCategories[targetIndex] = _a[0], parent.subCategories[dragItemIndex] = _a[1];
        setTimeout(function () {
            _this.restoreItemStyle();
        });
        var _a;
    };
    AccordionEditorComponent.prototype.showURL = function () {
        if (!this.item['_id']) {
            // this is just created, id not set
            this.alertify.warning('Please save the whole custom category settings and refresh your browser to getting the link');
            return;
        }
        var placeCalendarPath = routeConfigs.visitor.placeCalendar.path;
        var place = "" + placeCalendarPath.substr(0, placeCalendarPath.indexOf('/:'));
        var link = this.getPlaceWidgetUrlEmbedScript(place, this.item['_id']);
        var jsonApi = ConfigService.config.apiAddress + "v2.0/" + this.hubName + "/" + place + "?custom_category=" + this.item['_id'];
        this.modalService.show({
            component: ShowCategoryLinkModalComponent,
            providers: [
                { provide: ShowCategoryLinkModalActions, useValue: null },
                { provide: CategoryLinkModalData, useValue: new CategoryLinkModalData(link, jsonApi) },
            ],
            panelClass: 'width-modal-4',
        });
    };
    AccordionEditorComponent.prototype.addSubCategory = function () {
        var _this = this;
        this.item.subCategories.push(new PlaceType(!this.parent ? '2nd level' : '3rd level', this.item.level + 1));
        setTimeout(function () {
            _this.accordion && _this.accordion.open();
            _this.onSubCategoryAdded.emit(_this.item);
        });
    };
    AccordionEditorComponent.prototype.removeSubCategory = function () {
        var _this = this;
        // not 1st level
        if (this.parent) {
            this.parent.subCategories = this.parent.subCategories.filter(function (x) { return x.id !== _this.item.id; });
        }
        this.onRemoved.emit(this.item);
        // CustomizePlaceCategoryComponent will take care of the data to send to server side to remove the category from places
        this.customDefaultPlaceCategoryItemEditedStore.customDefaultPlaceCategoryItemEditedCommand.next({
            type: 'deleted',
            item: this.item,
        });
    };
    AccordionEditorComponent.prototype.enterEditMode = function (item) {
        item.isEditing = true;
        this.setCategories(item);
    };
    AccordionEditorComponent.prototype.updateCategoryTitle = function () {
        if (!/^[a-zA-Z0-9- ]+$/.test(this.tempTitle)) {
            this.alertify.warning('Category title can only contain letters, numbers and hyphens');
            return;
        }
        /**
         *   remove the category code same with the old name
         * */
        var code = PlaceService.toCategoryCode(this.item.title);
        if (this.item.categoryList.indexOf(code) >= 0) {
            this.item.categoryList = this.item.categoryList.filter(function (x) { return x !== code; });
        }
        var oldTitle = clone(this.item.title);
        this.item.title = clone(this.tempTitle);
        this.item.isEditing = false;
        /** after edited a category, need to notify the server side to update the existing places which hold this category. Subscribe in CustomizePlaceCategoryComponent */
        this.customDefaultPlaceCategoryItemEditedStore.customDefaultPlaceCategoryItemEditedCommand.next({
            type: 'edited',
            item: this.item,
            oldTitle: oldTitle,
            newTitle: this.item.title,
        });
    };
    AccordionEditorComponent.prototype.cancelUpdateTitle = function () {
        this.tempTitle = clone(this.item.title);
        this.item.isEditing = false;
    };
    AccordionEditorComponent.prototype.canAddSub = function () {
        return this.item.level < this.maxLevels - 1;
    };
    AccordionEditorComponent.prototype.clearFilter = function () {
        this.accordion && this.accordion.clearFilter(null, false);
    };
    AccordionEditorComponent.prototype.getPlaceWidgetUrlEmbedScript = function (place, placeId) {
        return "<div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/" + place + "/" + placeId + "/custom\" url-change=\"true\">\n             <app-root></app-root>\n            <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n        </div>";
    };
    return AccordionEditorComponent;
}(BaseComponent));
export { AccordionEditorComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/accordion.editor/accordion.editor.component.ts.pre-build-optimizer.js